import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getOrCreateCheckout, initClient, toggleCart } from "../../store/actions";
import { LANGUAGE_FR_CODE } from "../../constants/AppConstants";
import { SET_CURRENT_LANGUAGE, SET_CHECKOUT_ID } from "../../constants/ActionTypes";
import i18next from "i18next";
import CartEventTracker from "../../utils/events";
import { getCartId } from "../../utils/cookies-checkout";

/**
 * React app to show cart info in navigation bar
 *
 * @return {*}
 */
const NavMenu = () => {
  const dispatch = useDispatch();
  const isCartOpen = useSelector(state => state.common.isCartOpen);
  const { checkout } = useSelector(state => state.checkout);
  const langCode = document.getElementById("language-code")?.value || LANGUAGE_FR_CODE;
  const cartTracker = new CartEventTracker();

  /**
   * Init Shopify client
   * Get or create checkout for current user
   */
  useEffect(() => {
    const initializeApp = async () => {
      dispatch({
        type: SET_CURRENT_LANGUAGE,
        payload: langCode,
      });

      if (langCode?.length === 5) {
        i18next.changeLanguage(langCode);
      }
      const checkoutID = getCartId();
      console.log("Cart ID retrieved:", checkoutID);

      dispatch({ type: SET_CHECKOUT_ID, payload: checkoutID });
      await dispatch(initClient());
      dispatch(getOrCreateCheckout());
    };

    initializeApp();
  }, [dispatch, langCode]);

  /**
   * Handle Cart toggle
   */
  const handleToggleCart = () => {
    if (!isCartOpen) {
      cartTracker.viewCartEvent(checkout);
    }
    dispatch(toggleCart(!isCartOpen));
  };

  return (
    <div className="cart-navbar" onClick={() => handleToggleCart()}>
      <img src={`${process.env.IMAGES_BASE_URL}/static/vendors/images/icons/cart.svg`} alt="cart" />
      <div className="cart-count">
        {checkout?.lines?.edges?.length > 0 ? (
          <span>{checkout?.lines?.edges?.length}</span>
        ) : (
          <span>0</span>
        )}
      </div>
    </div>
  );
};
export default NavMenu;
